import Route from '@ember/routing/route';

export default class SettingVisitorTypesRoute extends Route {
  titleToken = 'Visitor types';
}
